import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import RiderPortalHome from "../views/RiderPortalHome";
import RiderPortalAccountHome from "../views/RiderPortalAccountHome";
import RiderPortalAllRideRequests from "../views/RiderPortalAllRideRequests";


export default function RiderPortal(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <RiderPortalHome/>
		} else if(
			appContext.navSubItem &&
			appContext.navExtraItem === 'account-home' &&
			!appContext.navMoreItem
		) {
			return <RiderPortalAccountHome riderUuid={appContext.navSubItem}  />
		} else if(
			appContext.navSubItem &&
			appContext.navExtraItem === 'all-ride-requests' &&
			!appContext.navMoreItem
		) {
			return <RiderPortalAllRideRequests riderUuid={appContext.navSubItem}  />
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}